const homeLandingES = {
	hero: {
		title:
			"Automatiza tus reservas, crece tu negocio.",
		subtitle:
			"Sin Fila organiza tus citas, da más visibilidad a tu negocio y facilita las reservas de tus clientes — todo en un solo lugar.",
		primaryCta: "Empieza Gratis Ahora",
		secondaryCta: "Explorar Servicios",
		platformStrong: "Perfecto para — ",
		platformRest: "Barberos • Salones • Spas • Tutores • ¡y mucho más!",
		freeTrial: "14 días ",
		freeTrialText: "de prueba gratis. Sin compromiso.", 
	},

	whatWeDo: {
		title: "Por qué los negocios aman Sin Fila",
		description:
			"Sin Fila conecta negocios con clientes mediante reservas digitales simples, rápidas y sin filas.",
	},

	business: {
		title: "Beneficios para negocios",
		intro:
			"Organiza tu agenda, automatiza citas y evita perder clientes.",
		items: [
			"Recibir reservas online 24/7",
			"Confirmaciones automáticas y recordatorios",
			"Horarios claros y sin cruces",
			"Perfil público para conseguir clientes nuevos",
			"Menos tiempo en WhatsApp — más tiempo trabajando",
		],
		cta: "Ir a espacio para negocios",
	},

	clients: {
		title: "Beneficios para clientes",
		
		intro:
			"Reserva tu cita en segundos, sin llamadas ni espera.",
		items: [
			"Ver disponibilidad real",
			"Reservar al instante",
			"Recibir recordatorios automáticos",
			"Reprogramar o cancelar sin estrés",
			"Encontrar barberías, salones y más cerca de ti",
		],
		cta: "Explorar negocios",
	},

	about: {
		title: "Cómo funciona",
		step1: "Paso 1",
		step1Text: "Regístrate en 15 minutos — sin contratos, sin complicaciones.",
		step2: "Paso 2",
		step2Text: "Tu agenda, lista sin complicaciones.",
		step3: "Paso 3",
		step3Text: "Reservas sin estrés.",
		paragraph1:
			"Crea tu perfil de negocio, agrega tus servicios, establece tu horario y prepara tu agenda para recibir reservas.",
		paragraph2:
			"Agrega tu personal, asigna roles y gestiona varias agendas. La programación automática evita reservas dobles y mantiene al equipo organizado.",
		paragraph3:
			"Tus clientes pueden reservar al instante. Confirmaciones, recordatorios y notificaciones mantienen a todos informados.",
	},

	dominican: {
		eyebrow: "¿Quiénes somos?",
		title: "Una empresa dominicana, creada para negocios dominicanos.",
		paragraph1:
			"Sin Fila nació con una misión: ayudar a los negocios dominicanos a modernizar la forma en que gestionan sus citas y hacer crecer sus negocios. Estamos orgullosamente registrados en la República Dominicana y comprometidos con apoyar a los emprendedores locales con una tecnología diseñada alrededor de las realidades de hacer negocios aquí.",
		paragraph2:
			"Nuestra visión es convertirnos en el socio tecnológico de confianza para miles de negocios dominicanos, ayudándolos a crecer, atender más clientes y avanzar hacia el futuro con confianza.",
		linkText: "Conoce más sobre nuestra historia",
	},

	finalCta: {
		text: "Empieza gratis con 14 días de prueba y gana con nuestro programa de referidos. Por cada referido exitoso, ambos salen ganando.",
	},

	testimonials: {
		title: "Lo que dicen nuestros clientes",
		items: [
			{
				quote:
					"Sin Fila me ha hecho mucho más fácil organizar mis citas y mi día. Mis clientes pueden reservar directamente, incluso para servicios a domicilio, y yo tengo todo organizado en un solo lugar.",
				name: "Sara",
				role: "Profesional de bienestar",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila me ha ayudado a tener mi agenda mucho más organizada y a reducir el tiempo que paso coordinando citas. También me permite que nuevos clientes me descubran y puedan reservar conmigo fácilmente.",
				name: "Pedro",
				role: "Barbero",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila me ayudó a organizar mucho mejor mi salón. Ahora puedo ver y gestionar las agendas de todo mi equipo desde un solo lugar, y es mucho más fácil coordinar los horarios y las citas.",
				name: "Maria",
				role: "Dueña de salón",
				location: "Santo Domingo",
			},
		],
	},

	businessPoints: [
		{
			title: "Nunca pierdas una reserva",
			desc: "Todas las citas, confirmaciones y recordatorios en un solo lugar.",
		},
		{
			title: "Atrae nuevos clientes y llena tu agenda",
			desc: "Muestra tu negocio a más clientes en nuestro marketplace.",
		},
		{
			title: "Ahorra tiempo gestionando tu negocio y tu equipo",
			desc: "Gestiona servicios y calendarios del personal fácilmente.",
		},
		{
			title: "Reservas simples para tus clientes",
			desc: "Los clientes reservan, modifican y reciben recordatorios automáticamente.",
		},
	],
};

export default homeLandingES;